import { AUTH_LOGIN_ENDPOINT, AUTH_SUCESSFULL_REPLY } from './auth.mocks';
import { DOC_TYPES_GET } from './document-types.mock';
import { rest } from 'msw';
import { WEBCOBERTURA } from '../config';
import {
  ENTITIES_GET_ENDPOINT,
  ENTITIES_OK_SINGLE_REPLY,
} from './commercial-entities.mock';
import {
  PHONE_COMPANIES_GET_OK_RESPONSE,
  PHONE_COMPANY_GET_ENDPOINT,
} from './phones.mocks';
import {
  SELLING_COMPANIES_GET_ENDPOINT,
  SELLING_COMPANIES_OK_REPLY,
} from './selling-companies.mock';

const addressMock = {
  id: '8588636',
  addressStreet: 'MASCAGNI',
  addressNumber: '2500',
  addressFloor: null,
  addressFlat: null,
  zipCode: '1686',
  cpa: 'B1686EYS',
  regionName: 'BUENOS AIRES',
  addressCity: 'HURLINGHAM',
  suburb: null,
  addressObservations: null,
  latitude: '-58.64385037',
  longitude: '-34.59805302',
  addressDepartment: 'HURLINGHAM',
  addressTower: null,
  addressWithinStreets: 'EJEMPLOINPUTENTRECALLES',
  cmpId: '2',
  clientAccountNumber: null,
  accountNumberId: '1284130877',
  accountServiceStatus: 'A',
  suspendedLines: false,
  product: '2 PLAY',
  linesQuantity: 0,
  acometido: 'N',
  mainIpTvForSale: 'S',
  cityId: '54',
  plans: [
    {
      lineType: 'TF',
      id: 'TELIP',
      description: 'Telefonía Fija',
      planType: 'Telefonia',
    },
  ],
  polygonId: '3150',
  provider: 'CLARO',
  technology: 'GPON',
};

const mockWithAddresses = [
  {
    ...addressMock,
    plans: [
      ...addressMock.plans,
      {
        lineType: 'IF',
        id: '20MBI',
        description: 'Internet Ilimitado 20MB',
        planType: 'Internet',
      },
    ],
  },
  {
    ...addressMock,
    id: '8588637',
    addressStreet: 'MORENO',
    accountNumberId: '1284130879',
    polygonId: '3152',
  },
  {
    ...addressMock,
    id: '8588638',
    addressStreet: 'MARTINEZ',
    accountNumberId: '1284130870',
    plans: [
      {
        lineType: 'IF',
        id: '20MBI',
        description: 'Internet Ilimitado 20MB',
        planType: 'Internet',
      },
    ],
    polygonId: '3153',
  },
  {
    ...addressMock,
    id: '8878748380',
    addressStreet: 'MALABIA',
    addressNumber: '7823',
    addressCity: 'CABA',
    addressDepartment: 'CABA',
    addressWithinStreets: 'GORRITI Y GUATEMALA',
    accountNumberId: '1284130876',
    plans: [
      {
        lineType: 'IF',
        id: '20MBI',
        description: 'Internet Ilimitado 20MB',
        planType: 'Internet',
      },
    ],
    polygonId: '3153',
  },
];

export const handlers = [
  // Dashboard.test
  rest.get(
    '/api/servicios_fijos/v1/users/service_requests',
    (req, res, ctx) => {
      return res(
        ctx.status(200),
        ctx.json({
          content: [
            {
              billingCity: 'CORDOBA',
              clientFirstName: 'TESTY',
              clientLastName: 'TEST',
              creationDate: '2021-11-03 12:17:27.0',
              idSDS: '00012173FAE',
              identificationNumber: '36285683',
              identificationType: 'DNI',
              portableNumber: null,
              product: '2 PLAY',
              stateDescription: 'OK',
              workOrderId: '21723',
            },
          ],
          first: true,
          last: false,
          number: 0,
          numberOfElements: 10,
          size: 10,
          totalElements: 229,
          totalPages: 23,
        })
      );
    }
  ),
  // Login.test
  rest.post(AUTH_LOGIN_ENDPOINT, (req, res, ctx) => {
    return res(ctx.status(200), ctx.set(AUTH_SUCESSFULL_REPLY));
  }),
  rest.get(`${ENTITIES_GET_ENDPOINT}/:username`, async (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(ENTITIES_OK_SINGLE_REPLY));
  }),
  rest.get(SELLING_COMPANIES_GET_ENDPOINT, (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(SELLING_COMPANIES_OK_REPLY));
  }),
  rest.get(AUTH_LOGIN_ENDPOINT, (req, res, ctx) => {
    return res(ctx.status(200), ctx.json({ response: 'Valid Token' }));
  }),
  // SearchDocument.test
  rest.get(DOC_TYPES_GET.URL, (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(DOC_TYPES_GET.OK_REPLY));
  }),
  rest.get('/api/servicios_fijos/v1/clients', (req, res, ctx) => {
    return res(
      ctx.status(404),
      ctx.json({
        code: '404',
        description:
          'El Cliente existe con el tipo de documento:DNI, ¡Modificalo!.',
        detail: null,
        severity: 'ERROR',
        status: 'ABORT',
        type: 'BUSINESS',
      })
    );
  }),
  rest.get('/api/servicios_fijos/v1/phones/:phone', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        phoneCompanies: [
          { name: 'Claro', companyName: 'Claro' },
          { name: 'Personal', companyName: 'Personal' },
          { name: 'Movistar', companyName: 'Movistar' },
          { name: 'Nextel', companyName: 'Nextel' },
          { name: 'Sin información', companyName: 'Sin información' },
        ],
      })
    );
  }),
  rest.get(
    '/api/servicios_fijos/v1/clients/phone_codes/:code',
    (req, res, ctx) => {
      return res(
        ctx.status(200),
        ctx.json({ nameCode: null, validCode: false, errorCode: -5 })
      );
    }
  ),
  rest.get('/api/servicios_fijos/v1/risks', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        risk: 'A',
        reason: 'FALLO CONEXION CON VERAZ',
        score: { value: 600.0, renewed: 'Y', range: 1.0 },
      })
    );
  }),
  // NewClient.test.tsx && ClientInfo.test.tsx
  rest.get(PHONE_COMPANY_GET_ENDPOINT, (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(PHONE_COMPANIES_GET_OK_RESPONSE));
  }),
  // RegionAutocomplete.test.tsx
  rest.get('/api/servicios_fijos/v1/domiciles/regions', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        regions: [{ id: 'MN', name: 'MONTEVIDEO' }],
      })
    );
  }),
  rest.get('/api/servicios_fijos/v1/reports/regions', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({ regions: [{ name: 'Cordoba' }, { name: 'Buenos Aires' }] })
    );
  }),
  rest.get('/api/servicios_fijos/v1/reports/departments', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        departments: [{ name: 'La Matanza' }, { name: '3 de febrero' }],
      })
    );
  }),
  // CityAutoComplete.test.tsx
  rest.get('/api/servicios_fijos/v1/domiciles/cities', (req, res, ctx) => {
    return res(ctx.status(200), ctx.json({ cities: [{ name: 'ANCON' }] }));
  }),
  // SuburbAutocomplete.test.tsx
  rest.get('/api/servicios_fijos/v1/domiciles/suburbs', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        suburbs: [{ name: 'CHAUVIN' }],
      })
    );
  }),
  // BillingDetail.tsx
  rest.get('/api/servicios_fijos/v1/billing_domiciles', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        billingDomicile: {
          cpa: '4400',
          province: 'SALTA',
          provinceId: 'ST',
          department: 'SALTA',
          street: 'M527A',
          streetNumber: '10',
          city: 'SALTA',
          suburb: '',
          partido: '',
          building: '',
          floor: '7',
          flat: 'A',
          zipCode: '4400',
          correctionStatus: 'NO ENCONTRADO',
          correctionId: '',
          isValidCPA: 'N',
          entreCalle: 'esto es una entre calle',
          manzana: 'M527A',
          lote: '10',
          torre: '2',
        },
        domicileDescription: 'description',
      })
    );
  }),
  rest.get(
    '/api/servicios_fijos/v1/payments/payment_types',
    (req, res, ctx) => {
      return res(
        ctx.status(200),
        ctx.json({
          paymentTypes: [
            {
              id: 'B',
              description: 'BANCO (VENTANILLA)',
              displayName: 'EFECTIVO',
            },
          ],
        })
      );
    }
  ),
  rest.get(
    '/api/servicios_fijos/v1/clients/iva_conditions',
    (req, res, ctx) => {
      return res(
        ctx.status(200),
        ctx.json({
          ivaConditions: [{ iva: 'CF', description: 'CONSUMIDOR FINAL' }],
        })
      );
    }
  ),
  rest.post(
    '/api/servicios_fijos/v1/payments/bank_entities',
    (req, res, ctx) => {
      return res(
        ctx.status(200),
        ctx.json({ code: '3', description: 'VISA BANCARD' })
      );
    }
  ),
  // Domicile.test
  rest.post(WEBCOBERTURA.URL, (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        data: {
          username: 'username',
        },
      })
    );
  }),
  // EntitiesPage
  rest.get('/api/servicios_fijos/v1/sellers', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        seller: {
          name: 'FULANITO',
          surname: 'COSME',
          documentNumber: '12345689',
          creditLimit: '1000',
          salesPlace: '491',
          status: 'ACTIVO',
          description: 'OK. El DNI pertenece a un vendedor activo.',
        },
      })
    );
  }),
  rest.get('/api/servicios_fijos/v1/employees/:username', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        employee: [
          {
            name: 'VENTASDEV',
            document: {
              documentType: '1-DNI',
              documentNumber: '99999999',
            },
            address: null,
            surname: 'VENTASDEV',
            sex: null,
            birthDate: '1987-09-17T03:00:00.000+0000',
            phoneNumber: null,
            legajo: '00099999',
            typeOfContract: 'NOMINA',
          },
        ],
      })
    );
  }),
  rest.get('/api/servicios_fijos/v1/work_orders', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        number: '17937',
        status: 'F',
        reason: 'INSTALADA EXITOSAMENTE',
      })
    );
  }),
  rest.get('/api/servicios_fijos/v1/service_requests', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        serviceRequests: [
          {
            id: '00009038FAE',
            description: 'OK',
            comment: null,
            creationDate: '2021-02-23 11:32:56.0',
          },
        ],
        message: {
          status: 'OK',
          messageTitle: '¡Buenísimo! Podés avanzar con el pedido.',
          messageSubTitle: 'El domicilio no tiene ninguna visita pendiente.',
        },
      })
    );
  }),
  rest.get(
    '/api/servicios_fijos/v1/delivery_domiciles/:addressNumber',
    (req, res, ctx) => {
      return res(
        ctx.status(200),
        ctx.json({
          addressAccountId: 8592990,
          identificationType: 'DNI',
          identificationNumber: '24151615',
          mainIPTVForSale: 'S',
        })
      );
    }
  ),
  rest.get(
    '/api/servicios_fijos/v1/delivery_domiciles/provinces/:region',
    (req, res, ctx) => {
      return res(
        ctx.status(200),
        ctx.json({
          deliveryDomiciles: mockWithAddresses,
          domicilesQuantity: mockWithAddresses.length,
        })
      );
    }
  ),
  rest.get(
    '/api/servicios_fijos/v1/payments/cbus/:cbuNumber/validated',
    (req, res, ctx) => {
      return res(
        ctx.status(200),
        ctx.json({
          cbu: {
            code: '150',
            description: 'BANCO H.S.B.C.',
          },
        })
      );
    }
  ),
  rest.get(
    '/api/servicios_fijos/v1/clients/portabilities/:phoneNumber',
    (req, res, ctx) => {
      return res(
        ctx.status(200),
        ctx.json({
          description:
            'El número seleccionado está disponible para ser portado',
          phoneCompany: 'PERS',
          portable: true,
          rangeType: 'CPP',
        })
      );
    }
  ),
  rest.get(
    '/api/servicios_fijos/v1/hub_bidirectional/user_validation',
    (req, res, ctx) => {
      return res(
        ctx.status(200),
        ctx.json({
          hubBidirectional: {
            userValidation: {
              permission: true,
              message: 'El usuario tiene permisos',
            },
          },
        })
      );
    }
  ),
  rest.get('/config-metadata', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        token: 'untoken',
        isTieredBonusFlagEnabled: true,
      })
    );
  }),

  // Plans DTH
  rest.get('/api/servicios_fijos/v1/plans/service_types', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        serviceTypes: [
          {
            serviceId: '31',
            serviceName: 'DTH MASIVO',
            businessType: 'DTH',
            defaultIptv: 1,
            maxIptv: 4,
          },
        ],
      })
    );
  }),
];
